import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Paper, Typography} from "@material-ui/core";
import {pageMargin} from "../../../utils/styles";
import PhoneIcon from '@material-ui/icons/Phone';
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import Separator from "../separator/Separator";
import useIsMobile from "../../../hooks/useIsMobile";
import ShowInMobile from "../responsive/ShowInMobile";
import {getCurrentYear} from "../../../utils";
import ChatBox from "./ChatBox";
import useDialogState from "../../../hooks/useDialogState";
import useConfirmationDialog from "../confirmationdialog/useConfirmationDialog";

const useStyles = makeStyles(theme => ({
    root: {
        ...pageMargin(theme)
    },
    contentPaper: {
        padding: theme.spacing(1, 2),
        backgroundColor: theme.palette.primary.main,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            alignItems: 'initial'
        }
    },
    contatoDiv: {
        '& span:first-child': {
            display: 'flex',
            justifyContent: 'center',
            color: '#f4ce30',
            marginBottom: theme.spacing(.5),
            fontSize: '.8rem',
            '& svg': {
                marginRight: theme.spacing()
            },
            [theme.breakpoints.up('sm')]: {
                justifyContent: 'flex-start'
            }
        },
        '& span:last-child': {
            color: 'white',
        },
        '& a': {
            color: 'white',
            textDecoration: 'none',
            '&:hover': {
                color: '#f4ce30'
            }
        }
    },
    copywritesDiv: {
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end'
        }
    },
    copywritesTypography: {
        color: '#CCCCCC',
        fontSize: '.9rem',
        textAlign: 'right'
    }
}));

export default function Footer(props) {
    const {
        showChat = false
    } = props;
    const classes = useStyles();
    const isMobile = useIsMobile();
    const confirmation = useConfirmationDialog();
    const {
        dialogState,
        openDialog,
        closeDialog
    } = useDialogState({
        chat: false
    });

    const onClickChat = event => {
        event.preventDefault();

        openDialog('chat')();
    };

    const onCloseChat = () => {
        confirmation('Tem certeza que deseja encerrar o atendimento online?',
            closeDialog('chat'));
    };

    return (
        <footer className={classes.root}>
            <Paper className={classes.contentPaper}>
                <div className={classes.contatoDiv}>
                    <span>
                        <PhoneIcon fontSize='small' />
                        Ribeirão Preto
                    </span>
                    <span>(16) 3603-7000 / 0800-7718388</span>
                </div>
                <Separator orientation={isMobile ? 'horizontal' : 'vertical'} noCenterText />
                <div className={classes.contatoDiv}>
                    <span>
                        <PhoneIcon fontSize='small' />
                        Guarujá
                    </span>
                    <span>(16) 3603-7000 / 0800-7718388</span>
                </div>
                {showChat && (
                    <>
                        <Separator orientation={isMobile ? 'horizontal' : 'vertical'} noCenterText />
                        <div className={classes.contatoDiv}>
                        <span>
                            <ChatOutlinedIcon fontSize='small' />
                            Atendimento Online
                        </span>
                            <a href='#' onClick={onClickChat}>Clique para ser atendido</a>
                        </div>
                    </>
                )}
                <ShowInMobile>
                    <Separator orientation='horizontal' noCenterText />
                </ShowInMobile>
                <div className={classes.copywritesDiv}>
                    <Typography className={classes.copywritesTypography}>© {getCurrentYear()} Unaerp. Todos os direitos reservados.</Typography>
                </div>
            </Paper>
            {showChat && (
                <ChatBox
                    open={dialogState.chat}
                    onClose={onCloseChat} />
            )}
        </footer>
    );
};

Footer.propTypes = {
    showChat: PropTypes.bool
};